// Dynamic import functions shared between App.js (React.lazy) and Home.js (background prefetch).
// Keeping the import() calls in one place means both usages resolve to the same webpack chunk.
export const loadAboutPage = () => import('./pages/about');
export const loadContactPage = () => import('./pages/Contact');
export const loadAwardsPage = () => import('./pages/Awards');
export const loadPress = () => import('./pages/press');
export const loadSocial = () => import('./pages/social');
export const loadSolar = () => import('./Servicers/Solar');
export const loadWater = () => import('./Servicers/Water');
export const loadITAutomation = () => import('./Servicers/It');
export const loadEVCharging = () => import('./Servicers/ev');
export const loadBrandingAdvertising = () => import('./Servicers/branding');
export const loadFilmProduction = () => import('./Servicers/film');
export const loadRaahiPage = () => import('./Servicers/Raahi');

let prefetched = false;

// Warms the chunk cache for every non-home route so later navigation is instant.
// Safe to call multiple times - only fetches once.
export function prefetchOtherRoutes() {
    if (prefetched) return;
    prefetched = true;

    [
        loadAboutPage,
        loadContactPage,
        loadAwardsPage,
        loadPress,
        loadSocial,
        loadSolar,
        loadWater,
        loadITAutomation,
        loadEVCharging,
        loadBrandingAdvertising,
        loadFilmProduction,
        loadRaahiPage,
    ].forEach((load) => {
        load().catch(() => {});
    });
}
